import {
    API_REQUEST,
    API_RESET,
} from '../../constants/api';

/**
 * Dispatch an HTTP request through the generic api saga.
 *
 * @param {Object}   options
 * @param {string}   options.key        Unique cache key. Multiple components
 *                                      can read the same key to share state.
 *                                      Convention: `<feature>/<operation>`,
 *                                      e.g. 'dashboard/folders'.
 * @param {string}   options.endpoint   Full URL (use the constants in
 *                                      components/global/Server/endpoints).
 * @param {string}   [options.method]   'GET' | 'POST' | 'PUT'. Default 'POST'.
 * @param {Object}   [options.data]     Request body (for POST/PUT).
 * @param {Function} [options.onSuccess] Optional callback fired with
 *                                       response.data on success.
 * @param {Function} [options.onError]   Optional callback fired with the
 *                                       error message string on failure.
 * @param {Function} [options.onProgress] Optional callback fired with a 0-100
 *                                        percentage during upload.
 * @param {boolean}  [options.silent]   If true, don't surface errors via the
 *                                      global ErrorFeedbackBar — caller will
 *                                      handle messaging itself.
 */
export const apiRequest = ({
    key,
    endpoint,
    method = 'POST',
    data,
    onSuccess,
    onError,
    onProgress,
    silent = false,
}) => ({
    type: API_REQUEST,
    key,
    endpoint,
    method,
    data,
    onSuccess,
    onError,
    onProgress,
    silent,
});

/** Clear cached state for a key (e.g. on unmount or after a write). */
export const apiReset = (key) => ({
    type: API_RESET,
    key,
});
